import { all, fork } from "redux-saga/effects"

//public
import LayoutSaga from "./layout/saga"
import OngSaga  from "./register/ong/saga"
import DocumentSaga from "./documents/saga"
import LedgerProfileSaga from "./ledger/saga"
import PassagerSaga from "./register/passager/saga"
import ProviderSaga  from "./register/provider/saga"
import PolicieSaga from "./policies/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(OngSaga),
    fork(LayoutSaga),
    fork(PassagerSaga),
    fork(ProviderSaga),
    fork(DocumentSaga),
    fork(LedgerProfileSaga),
    fork(PolicieSaga),
  ])  
}
